import { useMemo } from 'react';
import { matchPath } from 'react-router-dom';
import { routeConfig, RouteConfig } from '../utils/routeConfig';

const flattenRoutes = (routes: RouteConfig[]): RouteConfig[] => {
  const out: RouteConfig[] = [];
  for (const r of routes) {
    out.push(r);
    if (r.children?.length) out.push(...flattenRoutes(r.children));
  }
  return out;
};

const FLAT_ROUTES: RouteConfig[] = flattenRoutes(routeConfig);

/**
 * Resolve the RouteConfig entry that matches a pathname. Prefers exact
 * matches (end:true), then falls back to prefix matches for nested routes.
 *
 * Plain function rather than a hook so the transition resolver can compare
 * the previous and next pathnames in the same render without worrying
 * about hook-call ordering.
 */
export function matchRouteConfig(pathname: string): RouteConfig | null {
  for (const r of FLAT_ROUTES) {
    if (matchPath({ path: r.path, end: true }, pathname)) return r;
  }
  for (const r of FLAT_ROUTES) {
    if (matchPath({ path: r.path, end: false }, pathname)) return r;
  }
  return null;
}

export function useMatchedRoute(pathname: string): RouteConfig | null {
  return useMemo(() => matchRouteConfig(pathname), [pathname]);
}
